<template>
  <div>
    <b-container
      v-show="showBookingReview &&  !isBank && !isPromptpay && !isBankingApp && !isCard"
      class="container-content card-container shadow-lg translateYg"
    >
      <b-alert variant="danger text-center" :show="bookingReview.isUpdateBooking">
        {{ $t('warning.please_press_confirm_to_update') }}
      </b-alert>
      <div class="page-header">
        <h4 class="page-header-text">{{ headerText }}</h4>
      </div>
      <div v-if="isSubmit">
        <div class="text-center mb-4" id="bankTransfer">
          <h4>
            {{ $t('booking_review.your_payment_slip_has_been_submitted_successfully') }}
          </h4>

          <p>
            {{ $t('booking_review.your_payment_will_be_reviewed_soon') }}
          </p>
          <b-row class="my-3 justify-content-center">
            <b-card
              tag="article"
              class="mb-2"
              style="width: 900px; border-radius: 15px !important"
              border-variant="dark"
            >
              <b-card-text class="mb-0">
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.amount_to_be_transferred') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>
                      ฿ {{ totalString | toCurrencyNumber }}
                      {{ $t('booking_review.total') }}
                    </p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.bank_name') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>{{ $t('booking_review.kasikorn') }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.account_number') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>{{ $t('booking_review.058-1-98209-7') }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.account_name') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>{{ $t('booking_review.blue_services') }}</p>
                  </b-col>
                </b-row>
              </b-card-text>
              <b-img
                v-if="image && slip"
                center
                :src="slip"
                height="200"
                class="mb-3"
                style="border-radius: 10px"
                @click="showImage(slip)"
              ></b-img>

              <!-- <b-button
              href="#"
              variant="primary"
              @click="uploadImage"
              :disabled="isLoading"
            > -->
              <!-- <b-spinner small class="mr-2" v-if="isLoading"></b-spinner>
              {{ $t("booking_review.upload_payment_slip") }}</b-button
            > -->
              <!-- <input
              id="main_image"
              class="d-none"
              type="file"
              name="photo"
              @change="importMainImage($event)"
            /> -->
              <!-- <p v-if="image && slip" class="mt-3">{{ image.name }}</p> -->
            </b-card>
          </b-row>
          <b-row class="justify-content-center">
            <b-button href="#" variant="primary" @click="toMyBooking">
              {{ $t('button.return_to_my_booking') }}</b-button
            >
          </b-row>
          <!-- <b-row class="justify-content-center">
          <b-button
            href="#"
            variant="primary"
            @click="uploadImage"
            :disabled="!slip"
          >
            {{ $t("booking_review.submit") }}</b-button
          >
        </b-row> -->
        </div>
      </div>

      <!-- Update Booking -->
      <!-- Update with no additional price -->
      <div v-if="bookingReview.isUpdateBooking && parseInt(amount) <= 0">
        <div>
          <b-row>
            <b-col xl="3"></b-col>
            <b-col xl="6" class="px-4">
              <div v-if="bookingReview.method === 1" class="d-flex mb-3">
                <img
                  :src="bookingReview.maid.user.image_url"
                  class="avatar mr-4"
                  v-if="bookingReview.method === 1"
                />
                <div>
                  <p class="fullname text-grey" v-if="bookingReview.method === 1">
                    {{ fullName }}
                  </p>
                </div>
              </div>
              <BookedCredits v-if="!isBookingOneTime" />
              <div>
                <p class="date text-grey" v-if="startDateLabel && isBookingOneTime">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-calendar mb-1 mr-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                    />
                  </svg>
                  {{ startDateLabel }}
                </p>
                <p class="cleaning-type text-grey" v-if="isBookingOneTime">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-clock mb-1 mr-1"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                    />
                    <path
                      d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z"
                    />
                  </svg>
                  {{ serviceTime }}
                </p>
                <p class="cleaning-type text-grey">
                  <img src="@/assets/images/icons/broom.svg" width="20" height="20" class="mb-1" />
                  {{ service }}
                </p>
                <div class="cleaning-type text-grey d-flex">
                  <div class="mr-1">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      class="bi bi-geo-alt-fill mb-1 mr-1"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                      />
                    </svg>
                  </div>
                  <div>
                    {{ location }} {{ place }}
                    <div v-if="additional_details" class="cleaning-type text-grey d-flex"></div>
                    {{ additional_details }}
                  </div>
                </div>
              </div>

              <!-- <div id="map" ref="gmaps" style="height: 300px" class="my-2"></div> -->
              <div class="map-container">
                <iframe
                  v-if="true"
                  class="my-2 map-iframe"
                  :src="`https://maps.google.com/maps?q=${bookingReview.location.latitude}, ${bookingReview.location.longitude}&t=&z=14&ie=UTF8&iwloc=&output=embed`"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
              </div>
              <p class="cleaning-type text-grey">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-info-circle mb-1 mr-1"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                  <path
                    d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
                  />
                </svg>
                {{ $t('form_label.additional_info') }}
              </p>
              <b-form-group class="text-grey mb-0">
                <ol class="mb-0">
                  <li v-for="(a, i) in additional" :key="`additional-${i}`" class="col-8">
                    {{ a }}
                  </li>
                </ol>
              </b-form-group>

              <p class="cleaning-type text-grey description">
                {{ bookingReview.description || `-` }}
              </p>

              <b-col lg="12" class="pb-4 pt-2 px-0">
                <p
                  :class="{ 'text-danger': !equipment.bring_equipment }"
                  v-if="!bookingReview.isUpdateBooking"
                >
                  {{ equipment.text }}
                </p>
              </b-col>
              <b-col>
                <b-form-row v-if="!isBank && !isSubmit">
                  <b-col cols="4" md="3">
                    <b-button
                      variant="link"
                      size="md"
                      class="py-2 text-underline"
                      block
                      @click="goBack"
                      >{{ $t('button.go_back') }}</b-button
                    >
                  </b-col>
                  <b-col cols="8" md="9">
                    <b-button
                      variant="light"
                      size="md"
                      class="py-2 align-items-center"
                      @click="doBooking"
                      block
                      type="submit"
                      :disabled="canSelectDate"
                      style="background: #afb1b0; border-color: #afb1b0; color: white !important"
                      v-if="!canSelectDate"
                    >
                      {{ confirmButtonText }}
                    </b-button>
                    <b-button
                      variant="primary"
                      size="md"
                      @click="doBooking"
                      class="py-2 align-items-center"
                      block
                      type="submit"
                      :disabled="isLoading"
                      v-else
                    >
                      <b-spinner small class="mr-2" v-if="isLoading"></b-spinner>
                      {{ confirmButtonText }}
                    </b-button>
                  </b-col>
                </b-form-row>
              </b-col>
            </b-col>
            <b-col xl="3"></b-col>
          </b-row>
        </div>
      </div>
      <!-- Update with additional price -->
      <b-row
        v-if="
          !bookingReview.isUpdateBooking || (bookingReview.isUpdateBooking && parseInt(amount) > 0)
        "
      >
        <b-col xl="6" class="px-4">
          <div v-if="bookingReview.method === 1" class="d-flex mb-3">
            <img
              :src="bookingReview.maid.user.image_url"
              class="avatar mr-4"
              v-if="bookingReview.method === 1"
            />
            <div>
              <p class="fullname text-grey" v-if="bookingReview.method === 1">
                {{ fullName }}
              </p>
            </div>
          </div>
          <div>
            <p class="date text-grey" v-if="startDateLabel">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-calendar mb-1 mr-1"
                viewBox="0 0 16 16"
              >
                <path
                  d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                />
              </svg>
              {{ startDateLabel }}
            </p>
            <p class="cleaning-type text-grey">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                class="bi bi-clock mb-1 mr-1"
                viewBox="0 0 16 16"
              >
                <path
                  d="M8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
                />
                <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm7-8A7 7 0 1 1 1 8a7 7 0 0 1 14 0z" />
              </svg>
              {{ serviceTime }}
            </p>
            <p class="cleaning-type text-grey">
              <img
                :src="require('@/assets/images/icons/broom.svg')"
                width="20"
                height="20"
                class="mb-1"
              />
              {{ service }}
            </p>
            <div class="cleaning-type text-grey d-flex">
              <div class="mr-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-geo-alt-fill mb-1 mr-1"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10zm0-7a3 3 0 1 1 0-6 3 3 0 0 1 0 6z"
                  />
                </svg>
              </div>
              <div>{{ location }} {{ place }}</div>
            </div>
            <div v-if="additional_details" class="cleaning-type text-grey d-flex">
              <img
                :src="require('@/assets/images/icons/notepad.svg')"
                width="20"
                height="20"
                class="mr-1"
              />
              <div style="word-break: break-word">{{ additional_details }}</div>
            </div>
          </div>
          <!-- <address-detail :address="bookingReview.location"></address-detail> -->

          <!-- MAP -->
          <!-- <div id="map" ref="gmaps" style="height: 300px" class="my-2"></div> -->
          <div class="map-container">
            <iframe
              v-if="true"
              class="my-2 map-iframe"
              :src="`https://maps.google.com/maps?q=${bookingReview.location.latitude}, ${bookingReview.location.longitude}&t=&z=14&ie=UTF8&iwloc=&output=embed`"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
            ></iframe>
          </div>
          <p class="cleaning-type text-grey">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-info-circle mb-1 mr-1"
              viewBox="0 0 16 16"
            >
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
              <path
                d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
              />
            </svg>
            {{ $t('form_label.additional_info') }}
          </p>
          <b-form-group class="text-grey mb-0">
            <ol class="mb-0">
              <li v-for="(a, i) in additional" :key="`additional-${i}`" class="col-8">
                {{ a }}
              </li>
            </ol>
          </b-form-group>
          <!-- <div class="w-100"> -->
          <p class="cleaning-type text-grey description">
            {{ bookingReview.description || `-` }}
          </p>
          <b-col lg="12" class="pb-4 pt-2 px-0">
            <p :class="{ 'text-danger': !equipment.bring_equipment }">{{ equipment.text }}</p>
          </b-col>
        </b-col>

        <b-col xl="6" class="px-4">
          <div>
            <div class="d-flex justify-content-between font-weight-bold underline mb-3">
              <p class="text-black">{{ $t('booking_review.booking') }}</p>
              <p>{{ bookingType }}</p>
            </div>
          </div>
          <BookedCredits v-if="!isBookingOneTime" />

          <div>
            <div class="d-flex justify-content-between font-weight-bold underline mb-3">
              <p class="text-black">
                {{ bookingReview.duration.value }} {{ $t('alias.hour') }}
                <small class="text-grey" style="white-space: nowrap">{{
                  choseLessThanRecommended
                }}</small>
              </p>
              <p style="white-space: nowrap">฿ {{ amount | toCurrencyNumber }}</p>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-between font-weight-bold underline mb-3">
              <p class="text-black">{{ $t('booking_review.discount') }}</p>
              <p>฿ {{ totalDiscount > 0 ? '-' : '' }} {{ totalDiscount | toCurrencyNumber }}</p>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-between font-weight-bold underline mb-3">
              <p class="text-black">{{ $t('booking_review.vat') }}</p>
              <p>฿ {{ vat | toCurrencyNumber }}</p>
            </div>
          </div>

          <div class="d-flex justify-content-between font-weight-bold underline mb-3">
            <p class="text-black">
              {{ $t('alias.total') }}
            </p>
            <p>฿ {{ totalString ? totalString : amount | toCurrencyNumber }}</p>
          </div>
          <!-- </div>
        </div> -->
          <!-- <b-form-group
          :label="$t('form_label.coupon')"
          v-if="!bookingReview.isUpdateBooking && showApplyCouponSection"
        > -->
          <b-form-group
            :label="$t('form_label.coupon')"
            v-if="!bookingReview.isUpdateBooking && !isSubmit"
          >
            <b-input-group>
              <b-form-input
                :placeholder="$t('form_label.apply_coupon')"
                v-model="coupon"
              ></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" @click="applyCoupon">{{ $t('button.apply') }}</b-button>
              </b-input-group-append>
            </b-input-group>
            <small
              :class="{
                'text-success': isApplySuccess,
                'text-danger': !isApplySuccess,
              }"
            >
              {{ couponStatusLabel }}
            </small>
          </b-form-group>

          <b-form-group
            v-if="!isSubmit && parseInt(amount) > 0"
          >    
          <slot name="label" >
          <div style="padding-bottom: calc(0.375rem + 1px); color: #333333">
            <span class="mr-1">
              {{ $t('booking_review.payment_method') }}
            </span>
         <img
          :key="$i18n.locale"
          id="payment_method"
          alt="payment_method"
          src="../../assets/images/information-icon-black.svg"
          width="16"
          height="16"
          style="margin-top: -2px; display: inline-block; vertical-align: middle; padding: 0;"
          v-b-tooltip.hover.focus.click="{
            title: $t('warning.payment_warning'),
            placement: 'top',
            html: true
          }"
        />
          </div>
        </slot>
        <!-- <b-tooltip
          target="payment_method"
          placement="auto"
          triggers="hover focus click"
        >
          <span v-html="$t('warning.payment_warning')"></span>
        </b-tooltip> -->
            <b-input-group @change="isBank ? (isBank = !isBank) : null" class="border-payment" >
              <b-col class="d-flex flex-wrap px-0  pt-2 mb-36" cols="12">
                <b-col cols="12" sm="12" md="6" lg="6" xl="7" class="px-0">
                  <b-form-radio
                    v-model="paymentType"
                    autocomplete="off"
                    class="w-100 text-grey"
                    name="some-radios"
                    value="bank"
                    :class="{ 'text-primary': paymentType === 'bank' }"
                    >{{ $t('booking_review.bank_transfer') }}
                  </b-form-radio>
                </b-col>
                <b-col
                  :class="{ 'text-left': !isMobileXS, 'text-left ': isMobileXS }"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="mt-1 px-0 "
                >
                  <img src="./../../assets/images/bank_icon_update_v2.png" alt="" class="ml-gap-bank"/> </b-col
              ></b-col>
              <b-col class="d-flex flex-wrap px-0 pt-2" cols="12">
                <b-col cols="12" sm="12" md="6" lg="6" xl="7" class="px-0">
                  <b-form-radio
                    required
                    v-model="paymentType"
                    autocomplete="off"
                    class="w-100 text-grey mt-2"
                    name="some-radios"
                    value="promptpay"
                    :class="{ 'text-primary': paymentType === 'promptpay' }"
                  >
                    {{ $t('booking_review.promptpay') }}
                  </b-form-radio>
                </b-col>
                <b-col
                  :class="{ 'text-left': !isMobileXS, 'text-left': isMobileXS }"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="mt-1 px-0"
                >
                  <img src="./../../assets/images/promptpay.png" alt="" class="ml-gap-credit w-promptpay"/></b-col
              ></b-col>
                   <b-col class="d-flex flex-wrap px-0 pt-2" cols="12">
                <b-col cols="12" sm="12" md="12" lg="12" xl="12" class="px-0">
                  <b-form-radio
                    required
                    v-model="paymentType"
                    autocomplete="off"
                    class="w-100 text-grey mt-2"
                    name="some-radios"
                    value="mobile_banking"
                    :class="{ 'text-primary': paymentType === 'mobile_banking' }"
                  >
                    {{ $t('booking_review.mobile_banking') }}
                  </b-form-radio>
                </b-col>
                <b-col
                  :class="{ 'text-left': !isMobileXS, 'text-left': isMobileXS }"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="mt-1 px-0"
                >
                  <img src="./../../assets/images/mobile_banking.png" alt="" class="ml-gap-credit"/></b-col
              ></b-col>
               <b-col class="d-flex flex-wrap px-0 pt-2" cols="12">
                <b-col cols="12" sm="12" md="6" lg="6" xl="7" class="px-0">
                  <b-form-radio
                    required
                    v-model="paymentType"
                    autocomplete="off"
                    class="w-100 text-grey mt-2"
                    name="some-radios"
                    value="card"
                    :class="{ 'text-primary': paymentType === 'card' }"
                  >
                    {{ $t('booking_review.credit_debit_only') }}
                  </b-form-radio>
                </b-col>
                <b-col
                  :class="{ 'text-left': !isMobileXS, 'text-left': isMobileXS }"
                  cols="12"
                  sm="12"
                  md="12"
                  lg="12"
                  xl="12"
                  class="mt-1 px-0"
                >
                  <img src="./../../assets/images/credit_debit.png" alt="" class="ml-gap-credit w-credit mb-4"/></b-col
              ></b-col>
            </b-input-group>
          </b-form-group>
          <!-- <div class="warning-confirm" v-if="bookingReview.isUpdateBooking">
          <label class="warning-maid">
            {{ $t('warning.please_press_confirm_to_update') }}
          </label>
        </div> -->
         <b-form-row
          :class="{ 'mb-mobile-150': true }"
          v-if="!isBank && !isSubmit"
        >
          <b-col cols="4" md="3">
            <b-button
              variant="link"
              size="md"
              class="py-2 text-underline"
              block
              @click="goBack"
              >{{ $t('button.go_back') }}</b-button
            >
          </b-col>
          <b-col cols="8" md="9">
            <b-button
              variant="light"
              size="md"
              class="py-2 align-items-center"
              @click="doBooking"
              block
              type="submit"
              :disabled="canSelectDate"
              style="background: #afb1b0; border-color: #afb1b0; color: white !important"
              v-if="!canSelectDate"
            >
              {{ confirmButtonText }}
            </b-button>
            <b-button
              variant="primary"
              size="md"
              @click="doBooking"
              class="py-2 align-items-center"
              block
              type="submit"
              :disabled="isLoading"
              v-else
            >
              <b-spinner small class="mr-2" v-if="isLoading"></b-spinner>
              {{ confirmButtonText }}
            </b-button>
          </b-col>
        </b-form-row>
        </b-col>
      </b-row>
      <BaseModal id="warning-upload-image-fail">
        <div class="text-center">
          <p>{{ $t('warning.upload_image_fail') }}</p>
        </div>
      </BaseModal>
      <BaseModal id="warning-cannotselectday" size="lg">
        <div class="text-center py-5">
          <p>{{ $t('warning.you_have_booked_within_24_hour') }} {{ time_can_pay }}</p>
        </div>
      </BaseModal>
      <BaseModal id="warning-have-another-booking">
        <div class="text-center">
          <p>{{ $t('warning.have_another_booking') }}</p>
        </div>
      </BaseModal>
      <BaseModal id="warning-invalid-datetime">
        <div class="text-center">
          <p>{{ $t('error.invalid_datetime') }}</p>
          <p class="text-timestamp">{{ dateTimeTimezone }}</p>
        </div>
      </BaseModal>
      <BaseModal id="booking-suspended-modal" :hideCloseButton="true">
        <p>{{ $t('warning.suspended_modal') }}</p>
        <b-button block variant="primary" @click="goBack">
          {{ $t('booking_review.back_to_booking_page') }}
        </b-button>
      </BaseModal>
      <BaseModal id="slip-img" size="lg" centerd="true">
        <b-img
          center
          :src="image"
          alt="Center image"
          class="mt-3 mb-5 mx-0 px-0 width-image-modal"
          style="border-radius: 10px"
        ></b-img>
      </BaseModal>
    </b-container>
    <!-- Banking Payment Upload Slip -->
    <b-container
      v-show="isBank && !isSubmit"
      class="container-content card-container shadow-lg translateYg"
    >
      <div class="page-header">
        <h4 class="page-header-text">{{ $t('booking_review.payment') }}</h4>
      </div>
      <b-container fluid class="px-4">
      <div 
       :class="{ 'mb-mobile-150': true }">
        <div class="text-center" id="bankTransfer">
          <h5 class="text-primary">
            {{ $t('booking_review.the_booking_has_not_been_made_yet') }}
          </h5>
          <span class="text-grey">
          {{ $t('booking_review.please_upload_your_payment_slip_to_complete_your_booking') }}
          </span>
          <h5 class="my-3 text-grey" style="font-size: 1rem">
            {{ $t('booking_review.time_limit') }}
            {{ countDownHour }}
            <span style="white-space: nowrap">( {{ timeAt }} )</span>
          </h5>
          <b-row class="my-3 justify-content-center">
            <b-card
              tag="article"
              class="mb-2"
              style="width: 900px; border-radius: 15px !important"
              border-variant="dark"
            >
              <b-card-text class="mb-0">
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>
                      {{ $t('booking_review.amount_to_be_transferred') }}
                      <span style="font-size: 28px"> &nbsp; </span>
                    </p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>
                      <span style="font-size: 28px">฿ {{ totalString | toCurrencyNumber }} </span>
                      {{ $t('booking_review.total') }}{{ $t('booking_review.including_vat') }}
                    </p>
                    <!-- <p>{{ $t("booking_review.including_vat") }}</p> -->
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.bank_name') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>{{ $t('booking_review.kasikorn') }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.account_number') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>{{ $t('booking_review.058-1-98209-7') }}</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6" class="pr-1 text-right">
                    <p>{{ $t('booking_review.account_name') }}</p>
                  </b-col>
                  <b-col cols="6" class="ml-0 pl-1 text-primary text-left">
                    <p>{{ $t('booking_review.blue_services') }}</p>
                  </b-col>
                </b-row>
              </b-card-text>
              <b-img
                v-if="image"
                center
                :src="image"
                height="200"
                alt="Center image"
                class="mb-3"
                style="border-radius: 10px"
                @click="showImage(image)"
              ></b-img>

              <b-button
                href="#"
                :variant="!image || cannotSubmit ? 'primary' : 'outline-primary'"
                @click="uploadImage"
                :disabled="isLoading"
                class="width_180"
              >
                <b-spinner small class="mr-2" v-if="isLoading"></b-spinner>
                {{ $t('booking_review.upload_payment_slip') }}</b-button
              >
              <input
                id="main_image"
                class="d-none"
                type="file"
                accept="image/*"
                name="photo"
                @change="importMainImage($event)"
              />
              <!-- <p v-if="image" class="mt-3">{{ image.name }}</p> -->
            </b-card>
          </b-row>
          <b-row class="justify-content-center">
            <p class="text-danger" v-if="image && !cannotSubmit">
              {{ $t('booking_review.your_booking_is_not_complete') }}
            </p>
          </b-row>
          <div class="d-flex justify-content-between gap-4 max-500px">
          <b-button
            variant="link"
            class="py-2 button-cancel"
            @click="closeAllPaymentSteps"
          >
            {{ $t('button.cancel') }}
          </b-button>
            <b-button
              href="#"
              variant="primary"
              @click="toTop"
              class="width_180 "
              :disabled="!image || cannotSubmit || cannotSubmitAgain"
              style="width: 100% !important"
            >
              <span style="font-size: 1rem">{{ $t('booking_review.submit') }}</span></b-button
            >
           </div>
        </div>
      </div>
      </b-container>
    </b-container>
    <!-- isPromptpay payment -->
    <b-container
      v-show="isPromptpay && !isSubmit"
      class="container-content card-container shadow-lg translateYg"
    >
      <div class="page-header">
        <h4 class="page-header-text">{{ $t('booking_review.payment') }}</h4>
      </div>
      <b-container fluid class="px-4">
      <div 
       :class="{ 'mb-mobile-150': true }">
        <div class="text-center" id="bankTransfer">
          <h5 class="text-primary">
            {{ $t('booking_review.the_booking_has_not_been_made_yet') }}
          </h5>
          <span class="text-grey">
            {{ $t('booking_review.after_payment_via_qr_code') }}
          </span>
          <h5 class="my-3 text-grey" style="font-size: 1rem">
            {{ $t('booking_review.time_limit') }}
            {{ countDownHour }}
            <span style="white-space: nowrap">( {{ timeAt }} )</span>
          </h5>
          <div v-if="showPromptpayQrCode" class="contents-center">
            <div style="position: relative; display: inline-block;">
              <b-img
                center
                :src="qrPreviewUrl || promptpayQrUrl"
                height="200"
                alt="Center image"
                class="mb-3"
                :style="pollTimedOut ? 'filter: blur(4px);' : ''"
              ></b-img>
              <div
                v-if="pollTimedOut"
                @click="refreshPromptpayQr"
                style="
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -60%);
                  cursor: pointer;
                  text-align: center;
                "
              >
                <i 
                class="fas fa-sync-alt fa-2x text-white"
                style="text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);"
                ></i>
              </div>
            </div>
            <div v-if="showPromptpayQrCode && promptpayQrUrl && !pollTimedOut" class="mt-2 mb-3">
              <b-button
                variant="outline-primary"
                size="sm"
                @click="savePromptpayQr"
              >
                <i class="fas fa-download mr-1"></i>
                {{ $t('booking_review.save_qr_code') }}
              </b-button>
            </div>
          </div>
          <div v-else class="contents-center">
            <b-spinner variant="primary"  class="mr-2"></b-spinner>
          </div>
          <b-row class="my-3 justify-content-center">
          <div class="contents-center">
            <p class="text-primary">
             <span style="font-size: 28px">฿ {{ totalString | toCurrencyNumber }} </span>
               <br />{{ $t('booking_review.including_vat') }}
            </p>
          </div>
          </b-row>
           <h5 class="my-3 text-grey text-start max-500px px-4" style="font-size: 1rem">
            {{ $t('booking_review.open_bank_app') }} <br />
            {{ $t('booking_review.scan_qr_code') }} <br />
            {{ $t('booking_review.auto_update') }} <br />
            {{ $t('booking_review.time_limit_warning') }} <br />
            {{ $t('booking_review.duplicate_qr_code') }} 
          </h5>

          <div class="d-flex justify-content-between gap-4 max-500px">
          <b-button
            variant="link"
            class="py-2 button-cancel"
            @click="closeAllPaymentSteps"
          >
            {{ $t('button.cancel') }}
          </b-button>
           </div>
        </div>
      </div>
      </b-container>
    </b-container>
    <!-- Banking App Payment Method -->
    <b-container
      v-show="isBankingApp && !isSubmit"
      class="container-content card-container shadow-lg translateYg"
    >
      <div class="page-header">
        <h4 class="page-header-text">{{ $t('booking_review.payment') }}</h4>
      </div>
        <div class="text-center" id="bankTransfer">
          <h5 class="text-primary">
            {{ $t('booking_review.the_booking_has_not_been_made_yet') }}
          </h5>
          <div class="contents-center">
            <p class="text-primary">
            <span class="text-grey text-nowarp">
              {{ $t('booking_review.amount_to_be_transferred') }}
                <span style="font-size: 28px"> &nbsp; </span>
            </span>
             <span style="font-size: 28px">฿ {{ totalString | toCurrencyNumber }} </span>
              {{ $t('booking_review.total') }}{{ $t('booking_review.including_vat') }}
            </p>
          </div>
          <span class="text-grey">
            {{ $t('booking_review.please_select_bank') }}
          <img
          :key="$i18n.locale"
          id="payment_method"
          alt="payment_method"
          src="../../assets/images/information-icon-blue.svg"
          width="16"
          height="16"
          style="margin-top: -2px; margin-left: 4px; display: inline-block; vertical-align: middle; padding: 0;"
          v-b-tooltip.hover.focus.click="{
            title: $t('warning.banking_app_warning'),
            placement: 'bottom',
            html: true
          }"
          />
          </span>
        </div>
          <div class="bank-grid">
            <div
              class="bank-box"
              :class="{ 'bank-box--selected': selectedBank === 'KPlus' }"
              @click="selectBank('KPlus')"
            >
              <img :src="require('@/assets/images/bank/KPlus.png')" class="bank-icon" />
              <div class="bank-name">K Plus</div>
            </div>

            <div
              class="bank-box"
              :class="{ 'bank-box--selected': selectedBank === 'Bualuang' }"
              @click="selectBank('Bualuang')"
            >
              <img :src="require('@/assets/images/bank/Bualuang.png')" class="bank-icon" />
              <div class="bank-name">Bualuang</div>
            </div>

            <div
              class="bank-box"
              :class="{ 'bank-box--selected': selectedBank === 'Krungthai' }"
              @click="selectBank('Krungthai')"
            >
              <img :src="require('@/assets/images/bank/Krungthai.png')" class="bank-icon" />
              <div class="bank-name">Krungthai</div>
            </div>

            <div
              class="bank-box"
              :class="{ 'bank-box--selected': selectedBank === 'SCB' }"
              @click="selectBank('SCB')"
            >
              <img :src="require('@/assets/images/bank/SCB.png')" class="bank-icon" />
              <div class="bank-name">SCB</div>
            </div>

            <div
              class="bank-box"
              :class="{ 'bank-box--selected': selectedBank === 'Krungsri' }"
              @click="selectBank('Krungsri')"
            >
              <img :src="require('@/assets/images/bank/Krungsri.png')" class="bank-icon" />
              <div class="bank-name">Krungsri</div>
            </div>
          </div>
        <div class="d-flex justify-content-between mt-4 gap-4 max-500px" :class="{ 'mb-mobile-150': true }">
          <b-button
            variant="link"
            class="py-2 button-cancel"
            @click="closeAllPaymentSteps"
          >
            {{ $t('button.cancel') }}
          </b-button>
          <b-button
            variant="primary"
            class="py-2 align-items-center w-full button-confirm"
            @click="doBookingConfirm(MOBILE_BANKING_MAP[selectedBank])"
            :disabled="!selectedBank || isLoading"
          >
            <b-spinner small class="mr-2" v-if="isLoading"></b-spinner>
            {{ $t('button.confirm') }}
          </b-button>
        </div>
    </b-container>
    <!-- Credit Method -->
    <b-container
      v-show="isCard && !isSubmit"
      class="container-content card-container shadow-lg translateYg"
    >
      <div class="page-header">
        <h4 class="page-header-text">{{ $t('booking_review.payment') }}</h4>
      </div>
      <div class="text-center" id="bankTransfer">
        <h5 class="text-primary">
          {{ $t('booking_review.the_booking_has_not_been_made_yet') }}
        </h5>
        <div class="contents-center">
          <p class="text-primary">
            <span class="text-grey text-nowarp">
              {{ $t('booking_review.amount_to_be_transferred') }}
              <span style="font-size: 28px"> &nbsp; </span>
            </span>
            <span style="font-size: 28px">฿ {{ totalString | toCurrencyNumber }} </span>
            {{ $t('booking_review.total') }}{{ $t('booking_review.including_vat') }}
          </p>
        </div>
      </div>
      <b-form @submit.prevent="doBookingConfirm('card')">

        <b-form-group :label="$t('booking_review.cardholder_name')" class="text-start max-500px mx-auto">
          <b-form-input
            v-model="cardName"
            name="ccname"
            :placeholder="$t('booking_review.cardholder_name')"
            autocomplete="cc-name"
          ></b-form-input>
        </b-form-group>

        <b-form-group :label="$t('booking_review.card_number')" class="text-start max-500px mx-auto mt-3">
          <b-input-group class="cc-input-group">
            <b-form-input
              v-model="cardNumber"
              name="cardnumber"
              :placeholder="$t('booking_review.card_number')"
              maxlength="19"
              autocomplete="cc-number"
              @input="formatCardNumber"
            ></b-form-input>
            <b-input-group-append>
              <b-img
                :src="require('@/assets/images/bank/CreditType.png')"
                fluid
                alt="card types"
                class="credit-type-img"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>

        <b-form-row class="max-500px mx-auto mt-3">
          <b-col cols="6">
            <b-form-group :label="$t('booking_review.expiration_date')" class="text-start">
              <b-form-input
                v-model="cardExpiry"
                name="cc-exp"
                placeholder="MM/YY"
                maxlength="5"
                autocomplete="cc-exp"
                @input="formatCardExpiry"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="6">
            <b-form-group class="text-start">
              <template #label>
                <div class="d-flex align-items-center">
                  <span>CVV</span>
                </div>
              </template>
              <b-input-group class="cc-input-group cvv-input-group max-500px mx-auto">
                <b-form-input
                  id="cvv-input"
                  v-model="cardCvv"
                  name="cvc"
                  placeholder="CVV"
                  maxlength="3"
                  type="password"
                  autocomplete="cc-csc"
                  aria-describedby="cvv-info"
                ></b-form-input>
                <b-img
                  id="cvv-info"
                  src="@/assets/images/information-icon-black.svg"
                  alt="cvv info"
                  class="cvv-info-img"
                  v-b-tooltip.hover.focus="{
                    title: $t('booking_review.cvv_tooltip'),
                    placement: 'top',
                    html: false
                  }"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-form-row>

        <div class="d-flex justify-content-between mt-4 gap-4 max-500px" :class="{ 'mb-mobile-150': true }">
          <b-button
            variant="link"
            class="py-2 button-cancel"
            @click="closeAllPaymentSteps"
          >
            {{ $t('button.cancel') }}
          </b-button>
          <b-button
            type="submit"
            variant="primary"
            class="py-2 align-items-center w-full button-confirm"
            :disabled="isLoading || !creditCardFormValid"
          >
            <b-spinner small class="mr-2" v-if="isLoading"></b-spinner>
            {{ $t('button.confirm') }}
          </b-button>
        </div>

      </b-form>
    </b-container>
    <!-- <b-container v-show="!showBookingReview" class="container-content card-container translateYg text-center">
  <b-spinner  variant="primary" label="Spinning" class="text-center "></b-spinner>
  </b-container> -->
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import { Vue, Component, Watch } from 'vue-property-decorator'
import MaidDetail from '../../components/MaidDetail'
import AddressDetail from '../../components/Address'
import Moment from 'moment'
import ApiClient from '../../services'
import { MERCHANT_ID, PAYSOLUTION_URL, getReturnURL, getProductDetailFromType } from '../../config/constants'
import Constant, { ENABLE_APPLY_COUPON } from '../../config/booking'
import { post, isProduction, clone } from '../../utils'
import BookedCredits from '../../components/BookedCredits'
import { getPaySolutionCallbackURL, getEnvName, getOmisePublicKey } from '../../helpers/network'
import BaseModal from '../../components/Modal/BaseModal'
import { isUATEnv } from '../../helpers/network'
import Compressor from 'compressorjs'

import { equipmentMixin } from '../../mixins/booking/equipmentMixin'

import get from 'lodash/get'

const host = window.location.host
const env = getEnvName(host)

const BookingStore = createNamespacedHelpers('booking')
const UserStore = createNamespacedHelpers('user')
const AuthStore = createNamespacedHelpers('auth')
const postbackurl = getPaySolutionCallbackURL(env)
// const returnurl = getReturnURL()
let lat_google, lng_google

const PROMPTPAY_EXPIRY_MINUTES = 10
const PAYMENT_POLL_INTERVAL_MS = 1000
const SESSION_EXPIRY_HOURS = 3

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave'])

@Component({
  computed: {
    ...BookingStore.mapState(['bookingReview', 'isLog']),
    ...BookingStore.mapState({
      currentPaymentBody: 'paymentBody',
    }),
    ...UserStore.mapState(['email', 'is_verified_phone']),
    ...AuthStore.mapState(['callBackPathAfterWelcomePage', 'isLoggedIn']),
  },
  methods: {
    ...BookingStore.mapMutations([
      'setPaymentBody',
      'setBookingReview',
      'setSlipURL',
      'setReduce',
      'setDiscountPrice',
    ]),
    ...AuthStore.mapMutations(['setCallBackPathAfterWelcomePage']),
    ...AuthStore.mapActions(['signIn']),
    ...UserStore.mapActions(['getUserProfile']),
    ...BookingStore.mapActions(['processBooking', 'preBooking', 'uploadSlip']),
  },

  components: {
    MaidDetail,
    AddressDetail,
    BookedCredits,
    BaseModal,
  },
  mixins: [equipmentMixin],
})
export default class BookingReview extends Vue {
  cannotSubmitAgain = false
  preBooking_result = null
  image = null
  slip = ''
  gaBacK = false
  payments = []
  canSelectDate = true
  time_can_pay = null
  paymentType = 'bank'
  isBankingApp = false
  isPromptpay = false
  isCard = false
  cardName = ''
  cardNumber = ''
  cardExpiry = ''
  cardCvv = ''
  selectedBank = null
  isBank = false
  isSubmit = false
  allowLeave = false
  timeAt = Moment(60 * 60 * 1000)
  countDown = null
  image_2 = null

  // ------------------------
  isLoading = false
  isClickConfirmBooking = false
  isProcessingBooking = false
  couponStatusLabel = ''
  coupon = ''
  discount = 0
  paymentValue = {
    merchantid: MERCHANT_ID,
    refno: undefined,
    customeremail: undefined,
    productdetail: undefined,
  }
  type = null
  is_used_promotion = false
  prevRoute = {
    name: '',
  }
  showBookingReview = false

  booking_review_id = null
  interval = null
  sessionTimeout = null
  expiresAt = null
  
  tempPaymentBody = null
  tempPreBooking = null

  promptpayQrUrl = null
  qrFile = null
  qrPreviewUrl = null
  showPromptpayQrCode = false
  pollPaymentInterval = null
  isPollingPayment = false
  pollTimedOut = false
  waitingPaymentTimeout = null

  MOBILE_BANKING_MAP = {
    Bualuang: 'mobile_banking_bbl',
    KPlus: 'mobile_banking_kbank',
    Krungsri: 'mobile_banking_bay',
    Krungthai: 'mobile_banking_ktb',
    SCB: 'mobile_banking_scb',
  }

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  }

  beforeRouteLeave(to, from, next) {
    if (this.allowLeave) {
      next()
      return
    }

    if (this.isPromptpay || this.isBank || this.isBankingApp || this.isCard) {
      this.closeAllPaymentSteps()

      const currentUrl = window.location.pathname + window.location.search + window.location.hash
      if (currentUrl !== from.fullPath && window.history && window.history.pushState) {
        window.history.pushState(window.history.state, '', from.fullPath)
      }

      next(false)
      return
    }

    next()
  }

  closeAllPaymentSteps() {
    if (this.isPromptpay) {
      this.cancelPromptpay()
    }
    this.isBank = false
    this.isBankingApp = false
    this.isCard = false
    this.selectedBank = null
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  }

  selectBank(bank) {
    this.selectedBank = bank
  }

  formatCardNumber(e) {
    if (!this.cardNumber) return
    const digits = this.cardNumber.replace(/\D+/g, '').slice(0,16)
    this.cardNumber = digits.replace(/(.{4})/g, '$1 ').trim()
  }

  formatCardExpiry(e) {
    if (!this.cardExpiry) return
    const digits = this.cardExpiry.replace(/\D+/g, '').slice(0,4)
    if (digits.length <= 2) {
      this.cardExpiry = digits
    } else {
      this.cardExpiry = digits.slice(0,2) + '/' + digits.slice(2)
    }
  }

  async created() {
    if (!this.bookingReview.type) {
      let bookingState = JSON.parse(localStorage.bookingState)
      await this.setBookingReview(bookingState)
    }

    window.addEventListener('beforeunload', this.clearCurrentBookingReview)
    window.addEventListener('load', this.setCurrentBookingReview())
    console.log(this.prevRoute)
    // console.log("router", this.$router.history);
    // this.applyCoupon();

    this.expiresAt = Date.now() + SESSION_EXPIRY_HOURS * 60 * 60 * 1000
    this.checkExpiry()
    document.addEventListener('visibilitychange', this.onVisibilityChange)
  }

  beforeDestroy() {
    document.removeEventListener('click', this.hidePaymentTooltipOnScroll)
    this.clearCurrentBookingReview()
    if (this.pollPaymentInterval) {
      clearInterval(this.pollPaymentInterval)
      this.pollPaymentInterval = null
    }
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    if (this.sessionTimeout) {
      clearTimeout(this.sessionTimeout)
      this.sessionTimeout = null
    }
    if (this.waitingPaymentTimeout) {
      clearTimeout(this.waitingPaymentTimeout)
      this.waitingPaymentTimeout = null
    }
    if (this.qrPreviewUrl) URL.revokeObjectURL(this.qrPreviewUrl)
    document.removeEventListener('visibilitychange', this.onVisibilityChange)    
  }

  onVisibilityChange() {
    if (!document.hidden) this.checkExpiry()
  }

  checkExpiry() {
    clearTimeout(this.sessionTimeout)
    const remaining = this.expiresAt - Date.now()
    if (remaining <= 0) {
      alert('เซสชันหมดเวลา กรุณาเริ่มทำรายการจองใหม่อีกครั้ง\n\nYour session has expired. Please start a new booking.')
      this.$router.push({ name: 'Home' })
      return
    }
    this.sessionTimeout = setTimeout(this.checkExpiry, remaining)
  }  

  setCurrentBookingReview() {
    let bookingState = JSON.parse(localStorage.bookingState)
    let currentBookingReview = localStorage.currentBookingReview
      ? JSON.parse(localStorage.currentBookingReview)
      : []
    this.booking_review_id = this.$route.query.temp_id || this.$route.query.booking_id
    if (!currentBookingReview.find((item) => item == this.booking_review_id)) {
      currentBookingReview.push(this.booking_review_id)
      localStorage.setItem('currentBookingReview', JSON.stringify(currentBookingReview))
    }

    // if (
    //   currentBookingReview.filter((item) => item != this.booking_review_id && !!item).length > 0 &&
    //   (this.booking_review_id == bookingState.id || this.booking_review_id == bookingState.temp_id)
    // ) {
    //   this.$nextTick(() => {
    //     this.$root.$emit('bv::show::modal', 'warning-have-another-booking')
    //   })
    // }
  }

  clearCurrentBookingReview() {
    let currentBookingReview = localStorage.currentBookingReview
      ? JSON.parse(localStorage.currentBookingReview)
      : []
    if (currentBookingReview.find((item) => item == this.booking_review_id)) {
      currentBookingReview = currentBookingReview.filter(
        (item) => item != this.booking_review_id && !!item
      )
      localStorage.setItem('currentBookingReview', JSON.stringify(currentBookingReview))
    }
  }

  toMyBooking() {
    this.$router.push({ name: 'MyBooking' })
  }
  async toTop() {
    if (this.checkBookingSuspended()) return
    if (this.checkTimeCurrent()) {
      this.$root.$emit('bv::show::modal', 'warning-invalid-datetime')
      return
    }

    this.cannotSubmitAgain = true
    this.setReduce(this.totalString)

    let result_3 = await this.preBooking(false)
    console.log('result bank ', result_3)

    if (result_3 && result_3.data) {
      try {
        this.preBooking_result = result_3.data
        console.log('prebooking result', this.preBooking_result)
        const result = await this.uploadSlip({
          image: this.image_2,
          booking_id: this.preBooking_result.id,
        })
        // console.log("this.paymentBody.refno", this.paymentBody.refno);
        isProduction() &&
          this.$gtag.event('conversion', {
            send_to: 'AW-685115829/6OegCM_e6eIBELWT2MYC',
            transaction_id: this.paymentBody.refno || '',
          })

        console.log('presult.slip_url', result.slip_url)
        // this.image = convert;
        if (result.slip_url) {
          localStorage.isRedirect = 'false'
          this.slip = result.slip_url
          this.isSubmit = true
          this.setSlipURL(this.slip)
          this.cannotSubmitAgain = false
          // window.scrollTo({ top: 0, behavior: 'smooth' });

          // console.log("string", this.totalString);
          const total = parseFloat(this.bookingReview.total * 1.07).toFixed(2)
          dataLayer.push({ event: 'order_confirm', order_value: total })
          this.allowLeave = true
          this.$router.push({ name: 'Slip Confirm' })
        }
      } catch (e) {
        console.error('error sentry', e)
        this.cannotSubmitAgain = false
        // this.$root.$emit('bv::show::modal', 'warning-upload-image-fail')
      }
    } else {
      console.error('error sentry', result_3)
      this.cannotSubmitAgain = false
      // this.$root.$emit('bv::show::modal', 'alert-network-error')
    }
  }

  hidePaymentTooltipOnScroll() {
    const trigger = document.getElementById('payment_method')
    if (
    event &&
    event.type === 'click' &&
    trigger &&
    (trigger === event.target || trigger.contains(event.target))
  ) {
    return
  }
    this.$root.$emit('bv::hide::tooltip', 'payment_method')
  }

  async mounted() {
    this.$store.commit('setIsLoading', true)
    console.log('CONDITION TYPEOF', typeof this.bookingReview.location.additional_details)
    localStorage.isFromBookingReview = 'booking-review'
    console.log('bookingReview', this.bookingReview.location)
    document.addEventListener('click', this.hidePaymentTooltipOnScroll)

    let publicKey = getOmisePublicKey(env)
    if (window.Omise && publicKey) {
      window.Omise.setPublicKey(publicKey);
    }
    
    try {
      this.showBookingReview = false
      if (this.isLoggedIn) {
        await this.getPaymentHistory()
      }

      this.paymentValue.customeremail = this.email || 'noemail@bluuu.co'
      this.paymentValue.productdetail = this.booking_type
      this.bookingReview.total = this.bookingReview.amount
      // console.log('prevRoute', this.prevRoute)
      let booking_detail_local
      if (localStorage.booking_detail) {
        booking_detail_local = JSON.parse(localStorage.booking_detail)
      }
      if (this.prevRoute.name === 'Home' || this.prevRoute.name === 'VerifyPhone' || this.prevRoute.name === 'PaymentResult') {
        this.paymentType = localStorage.paymentType
        if (typeof this.bookingReview.coupon_body && this.bookingReview.coupon_body) {
          this.coupon = booking_detail_local.coupon_body.code
          await this.applyCoupon()
        }
        if (JSON.stringify(booking_detail_local.coupon_body) === 'true') {
          this.coupon = 'THAIWIN7'
          await this.applyCoupon()
        }
        if (
          typeof this.bookingReview.coupon_body &&
          this.bookingReview.coupon_body &&
          this.prevRoute.name === 'VerifyPhone' &&
          localStorage.isRedirect == 'true'
        ) {
          await this.doBooking()
          // this.initMaps()
          return
        }
      }
      if (this.bookingReview.isUpdateBooking && parseInt(this.amount) == 0) {
        await this.doBooking()
        return
      }

      if (this.bookingReview.isUpdateBooking && this.$route.query.booking_id) {
        const result = await ApiClient.bookingDetail(this.$route.query.booking_id)
        if(result && result.data && result.data.booking_calendars){
          let allCanceled = result.data.booking_calendars.every(calendar => calendar.status === 'CANCELED_BY_CUSTOMER');
          if(allCanceled){
            this.$router.push({ name: 'PaymentResult' , query: { error: "cannot_update" } })
            return
          }
        }
      }
      console.log('onShowBookingReviewChanged', 1)
      // this.initMaps()
    } catch (error) {
      console.log(error)
    } finally {
      this.showBookingReview = true
      this.$store.commit('setIsLoading', false)
    }
  }

  initMaps(latitude, longtitude) {
    let lat = this.bookingReview.location.latitude
    let long = this.bookingReview.location.longitude
    // let center = new google.maps.LatLng(lat, long)

    // let maps = new google.maps.Map(this.$refs.gmaps, {
    //   zoom: 15,
    //   center: new google.maps.LatLng(lat, long),
    //   mapTypeId: google.maps.MapTypeId.ROADMAP,
    // })
    // let marker = new google.maps.Marker({
    //   position: center,
    //   map: maps,
    //   // visible: true, ไม่จำเป็นต้องเปิดก็ได้
    // })
    // marker.setMap(maps)
  }

  get originalPrevRoute() {
    if (this.prevRoute.name === 'PaymentResult') {
      return this.prevRoute.query.prevRoute || ''
    }
    return this.prevRoute.name ? this.prevRoute.fullPath || '' : ''
  }

  goBack() {
    this.$root.$emit('bv::hide::modal', 'booking-suspended-modal')
    if (this.originalPrevRoute) {
      this.$router.push(this.originalPrevRoute)
    } else {
      if (this.booking_type == 'MULTI_PACKAGE') {
        this.$router.push({ name: 'BookingMultiPackage' })
      } else {
        this.$router.push({ name: 'BookingOneTime' })
      }
    }
  }

  get returnUrl() {
    const base = getReturnURL()
    return base
  }

  get isMobileXS() {
    let x = false
    screen.width < 425 ? (x = true) : (x = false)
    return x
  }

  get showApplyCouponSection() {
    return ENABLE_APPLY_COUPON
  }

  get choseLessThanRecommended() {
    const { accommodation, duration, services } = this.bookingReview

    if (!accommodation || !duration || accommodation.value === 'OTHERS') {
      return ''
    }

    const recommend = {
      CONDO_1_BR: [3, 4],
      CONDO_2_BR: [4, 5],
      CONDO_3_BR: [5, 6],
      CONDO_4_BR: [6, 8],
      HOUSE_1_STORY: [3, 4],
      HOUSE_2_STORIES: [4, 6],
      HOUSE_3_STORIES: [6, 8],
      OFFICE: [3, 4],
    }

    const acc = accommodation.value
    const base = recommend[acc]
    if (!base) return ''

    let [minH, maxH] = base

    const svc = services && services.value
    
    if (svc === 'DRAPERY') return ''

    if (svc === 'CLEANING_DRAPERY') {
      minH += 1
      maxH += 1
    }

    const num = duration.value

    let lessThan = ''
    if (num < minH) {
      lessThan = `${minH - num}-${maxH - num}`
    }

    return lessThan === ''
      ? ''
      : `( ${this.$t('form_label.less_than_recommended_durations')} ${lessThan} ${this.$t(
          'alias.hrs'
        )} )`
  }

  uploadImage() {
    document.getElementById('main_image').click()
  }
  compressImage(file) {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        quality: 0.6,
        success(result) {
          resolve(result)
        },
        error(e) {
          reject(e)
        },
      })
    })
  }
  showImage(item) {
    if (this.slip) {
      this.slip = item
      this.image = item
    } else {
      this.image = item
    }
    this.$root.$emit('bv::show::modal', 'slip-img')
  }
  async importMainImage(e) {
    this.image = null
    this.slip = null
    const file = e.target.files[0]

    if (!file) {
      this.isLoading = false
      return
    }

    if (file.type.indexOf('image') === -1) {
      // this.$root.$emit('bv::show::modal', 'warning-upload-image-fail')
      this.isLoading = false
      e.target.value = ''
      return
    }

    this.isLoading = true

    try {
      let convertedImage
      try {
        convertedImage = await this.compressImage(file)
      } catch (error) {
        console.error(error)
      }

      if (convertedImage) {
        this.image = URL.createObjectURL(convertedImage)
        this.image_2 = convertedImage
      } else {
        if (file.size > 5 * 1024 * 1024) {
          // 5 MB
          // this.$root.$emit('bv::show::modal', 'warning-upload-image-fail')
          e.target.value = ''
        } else {
          this.image = URL.createObjectURL(file)
          this.image_2 = file

          const image = new Image()
          image.src = this.image

          image.onload = () => {
            console.log('Image loaded successfully')
          }
          image.onerror = () => {
            console.error('Error loading the image')
            // this.$root.$emit('bv::show::modal', 'warning-upload-image-fail')
            e.target.value = ''
            this.image = null
            this.image_2 = null
          }
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      this.isLoading = false
    }
  }

  requireAuthIfNotLoggedIn() {
    if (!this.isLoggedIn) {
      this.$root.$emit('bv::show::modal', 'require-auth-modal')
      return false
    }
    return true
  }

  async doSignIn() {
    // this.setCallBackPathAfterWelcomePage('/booking-review')
    this.$root.$emit('bv::hide::modal', 'require-auth-modal')
    // this.signIn()
  }
  async getPaymentHistory() {
    try {
      const result = await ApiClient.paymentHistory({
        page: 1,
        limit: 20,
      })
      const { payment } = result.data

      this.payments = payment[0]

      const dateFormat = this.$i18n.locale === 'th' ? `DD MMM YYYY, H:mm` : `MMM DD, YYYY, H:mm`
      // let {time_pay, time_now} = null
      let time_pay = new Date(payment[0].create_datetime)
      let time_now = new Date()
      let time_can_pay = new Date(time_pay.getTime() + 60 * 60 * 24 * 1000)

      this.time_can_pay = Moment(time_can_pay).locale(this.$i18n.locale).format(dateFormat)
      this.$i18n.locale === 'th' ? this.time_can_pay + ' น.' : null
      if (time_now <= time_can_pay) {
        // ปิด function สำหรับทำรายการ 24 hr
        // this.canSelectDate = false
      } else {
        null
      }
      // console.log("can select", this.canSelectDate);
    } catch (e) {
      console.log(e.response)
    }
  }

  checkBookingSuspended() {
    const bookingState = JSON.parse(localStorage.bookingState)
    const isSuspended = !(
      this.booking_review_id == bookingState.id || this.booking_review_id == bookingState.temp_id
    )
    if (isSuspended) {
      this.$root.$emit('bv::show::modal', 'booking-suspended-modal')
    }
    return isSuspended
  }

  checkTimeCurrent() {
    const current_date = localStorage.getItem('currentDate') || new Date()
    const currentTime = new Date().getTime()
    const dateThreshold = 1000 * 60 * 60 // 1 hour in milliseconds
    const wrong_current_date =
      current_date && Math.abs(new Date(current_date).getTime() - currentTime) > dateThreshold
    this.dateTimeTimezone = this.getDateTimeTimezone()
    return wrong_current_date && !this.isAdmin
  }

  get isAdmin() {
    let adminToken = window.localStorage.getItem('admin_token')
    return this.isLoggedIn && adminToken && adminToken !== 'null'
  }

  async doBooking() {
    if (this.isProcessingBooking) {
      console.warn('doBooking is already in progress, ignore duplicate click')
      return
    }
    this.isProcessingBooking = true
    try {
      return await this.doBookingInternal()
    } finally {
      this.isProcessingBooking = false
    }
  }

  async doBookingInternal() {
    if (this.checkBookingSuspended()) return
    if (this.checkTimeCurrent()) {
      this.$root.$emit('bv::show::modal', 'warning-invalid-datetime')
      return
    }
    localStorage.paymentType = this.paymentType
    this.saveBookingDetailToLocalStorage()
    this.setReduce(this.totalString)

    this.isClickConfirmBooking = true

    const canNext = this.requireAuthIfNotLoggedIn()
    let paymentBody = {
      ...clone(this.paymentBody),
      customeremail: this.$store.state.user.email || 'noemail@bluuu.co',
    }
    this.saveBookingDetailToLocalStorage()
    this.setPaymentBody(paymentBody)
    this.savePaymentBodyToLocalStorage(paymentBody)
    // console.log('eeee:user')
    if (!canNext) return

    await this.getUserProfile() // Ensure data payload

    paymentBody = {
      ...clone(this.paymentBody),
      customeremail: this.$store.state.user.email || 'noemail@bluuu.co',
    }

    this.setPaymentBody(paymentBody)

    this.saveBookingDetailToLocalStorage()
    this.savePaymentBodyToLocalStorage(paymentBody)
    // alert(this.bookingReview.total)
    if (this.bookingReview.total === 0) {
      this.$router.push({ name: 'PaymentResult' })
      return
    }

    this.isLoading = true
    if (this.paymentType === 'card' || this.paymentType === 'promptpay' || this.paymentType === 'mobile_banking') {
      if (this.is_verified_phone) {
        // console.log("can't book",this.canSelectDate);
        // if (!this.canSelectDate) {
        //   this.$root.$emit('bv::show::modal', 'warning-cannotselectday')
        //   setTimeout(() => {
        //     this.$root.$emit('bv::hide::modal', 'warning-cannotselectday')
        //   }, 3000)
        //   await this.preBooking(false)
        //   // this.processBooking(false)
        // }
        // else {
        try {
          this.setReduce(this.totalString)
          this.tempPaymentBody = paymentBody
          window.scrollTo({ top: 0, behavior: 'smooth' })
          switch (this.paymentType) {
            case 'card':
              this.isCard = true
              break
            case 'promptpay':
              this.promptpayQrUrl = null
              this.qrFile = null
              if (this.qrPreviewUrl) {
                URL.revokeObjectURL(this.qrPreviewUrl)
                this.qrPreviewUrl = null
              }
              this.showPromptpayQrCode = false
              this.countDown = null
              this.timeAt = null
              this.pollTimedOut = false
              this.isPromptpay = true
              this.doBookingConfirm('promptpay')
              break
            case 'mobile_banking':
              this.isBankingApp = true
              break
          }
          // console.log(this.bookingReview)
          // console.log(paymentBody);
          // post(PAYSOLUTION_URL, {
          //     ...paymentBody,
          //     productdetail: getProductDetailFromType(paymentBody.productdetail)
          //   })
          this.isLoading = false
        } catch (e) {
          console.error('error sentry', e)
          // this.$root.$emit('bv::show::modal', 'warning-upload-image-fail')
          this.cannotSubmitAgain = false
        }
        // } // redirect to paysolution
      } else {
        this.setReduce(this.totalString)
        // await this.preBooking(false)
        this.setPaymentBody(paymentBody)
        this.$router.push({ name: 'VerifyPhone' })
      } ///upload Slip
    } 
    else if (this.paymentType === 'bank') {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      if (this.is_verified_phone) {
        if (this.bookingReview.isUpdateBooking && parseInt(this.amount) == 0) {
          this.showBookingReview = false
        } else {
          this.showBookingReview = true
        }
        // console.log("can't book",this.canSelectDate);
        // if (!this.canSelectDate) {
        //   this.$root.$emit('bv::show::modal', 'warning-cannotselectday')
        //   setTimeout(() => {
        //     this.$root.$emit('bv::hide::modal', 'warning-cannotselectday')
        //   }, 3000)
        //   //  this.processBooking(false);
        // }
        // else {
        if (this.$i18n.locale == 'th') {
          Moment.locale(this.$i18n.locale)
          // console.log('th')
        }

        // console.log("paymentBody", paymentBody);

        if (this.interval) {
          clearInterval(this.interval)
        }

        this.countDown = Moment(60 * 60 * 1000)

        this.timeAt = Moment(this.$momentTZ().locale(this.$i18n.locale))
          .add(1, 'hours')
          .format('H:mm, ddd DD MMM YYYY')

        console.log('timeAt', this.timeAt, this.$momentTZ())
        this.isBank = true
        this.isLoading = false

        const bankExpMoment = Moment().add(1, 'hours')
        this.interval = setInterval(() => {
          const remaining = bankExpMoment.diff(Moment())
          if (remaining <= 0) {
            this.countDown = Moment(0)
            clearInterval(this.interval)
            this.interval = null
            if (!this.isSubmit) {
              this.allowLeave = true
              this.$router.push({ name: 'TimeOut' })
            }
            return
          }
          this.countDown = Moment(remaining)
        }, 1000)
        //}

        // Scroll to the bank transfer section
        // this.$nextTick(() => {
        //   const bankTransferElement = document.getElementById('bankTransfer')
        //   if (bankTransferElement) {
        //     bankTransferElement.scrollIntoView({ behavior: 'smooth' })
        //   }
        // })
      } else {
        this.setReduce(this.totalString)
        // await this.preBooking(false)
        // this.processBooking(false);
        this.setPaymentBody(paymentBody)
        this.$router.push({ name: 'VerifyPhone' })
      }
    }
  }

  async confirmPayment(omise_type = null) {
    const localTempPreBooking = localStorage.tempPreBooking ? JSON.parse(localStorage.tempPreBooking) : null
    if (this.$route.query.ref_no && localTempPreBooking && localTempPreBooking.ref_no === this.$route.query.ref_no) {
      this.tempPreBooking = localTempPreBooking
    }
    if (this.tempPreBooking && this.tempPreBooking.booking_id && this.tempPreBooking.total == this.totalString) {
      return this.tempPreBooking
    }
    let paymentBody = this.tempPaymentBody
    let result_2 = await this.preBooking(false)
    console.log('result PAY ', result_2)
    if (result_2 && result_2.data.id) {
      const confirmPayment = {
        booking_id: result_2.data.id,
        ref_no: paymentBody.refno,
        omise_type: omise_type,
      }
      localStorage.confirmPayment = JSON.stringify(confirmPayment)
      let tempPreBooking = {
        ...confirmPayment,
        ...paymentBody,
      }
      this.tempPreBooking = tempPreBooking
      this.$router.replace({ query: { ...this.$route.query, ref_no: paymentBody.refno } })
      localStorage.setItem('tempPreBooking', JSON.stringify(tempPreBooking))
      return tempPreBooking
    } else {
      console.error('error sentry', result_2)
      this.isLoading = false
      // this.$root.$emit('bv::show::modal', 'alert-network-error')
      return false
    }
  }

  async doBookingConfirm(paymentType) {
    this.isLoading = true
    if (paymentType === 'card') {
      if (!this.creditCardFormValid) {
        return
      }
      let [exp_month, exp_year] = this.cardExpiry.split('/')
      const card = {
        name: this.cardName,
        number: this.cardNumber.replace(/\s/g, ''),
        expiration_month: exp_month,
        expiration_year: '20' + exp_year,
        security_code: this.cardCvv,
      }

      window.Omise.createToken('card', card, async (statusCode, response) => {
        if (response.object === 'error') {
          let message_text = 'SET YOUR SECURITY CODE CHECK FAILED MESSAGE'
          if (response.object === 'error') {
            message_text = response.message
          }
          alert(message_text)
          this.isLoading = false
        } else {
          const token = response.id
          let confirmPaymentResult = null
          try {
            confirmPaymentResult = await this.confirmPayment(paymentType)
            if (!confirmPaymentResult) {
              throw new Error('Payment confirmation failed. Please try again.')
            }
            console.log('confirmPaymentResult', confirmPaymentResult)
            console.log('statusCode, response', statusCode, response)
            let data_req = this.dataPaymentResult()
            const params = new URLSearchParams({
              ref_no: confirmPaymentResult.ref_no,
              is_update_booking: this.bookingReview.isUpdateBooking || false,
              prevRoute: this.originalPrevRoute,
              currentRoute: this.$route.fullPath || '',
            })
            const res = await ApiClient.omisePayment({
              omise_token_id: token,
              omise_detail: response,
              omise_type: 'card',
              booking_id: confirmPaymentResult.booking_id,
              ref_no: confirmPaymentResult.ref_no,
              total: confirmPaymentResult.total,
              payment_result: confirmPaymentResult,
              return_uri: `${this.returnUrl}?${params.toString()}`,
              data_req
            })

            if (res && res.data) {
              console.log('omisePayment res', res.data)
              if (res.data.message === 'successful') {
                this.allowLeave = true
                this.$router.push({ name: 'PaymentResult', query: { ref_no: confirmPaymentResult.ref_no, is_update_booking: this.bookingReview.isUpdateBooking || false } })
              } else if (res.data.message === 'pending_authorization' && res.data.authorize_uri) {
                window.location.href = res.data.authorize_uri
              } else {
                alert(res.data.message || 'Payment failed. Please try again.')
              }
            } else {
              alert('Payment failed. Please try again.')
            }
          } catch (error) {
            console.error('Payment confirmation error:', error)
            const errorCode = error.response && error.response.data && error.response.data.error
            if (errorCode === 'existing_payment' && confirmPaymentResult) {
              this.allowLeave = true
              this.$router.push({ name: 'PaymentResult', query: { ref_no: confirmPaymentResult.ref_no, is_update_booking: this.bookingReview.isUpdateBooking || false } })
            } else {
              alert(
                error.response && error.response.data && error.response.data.message
                  ? error.response.data.message
                  : error.response && error.response.data && error.response.data.error
                  ? error.response.data.error
                  : 'An error occurred during payment confirmation. Please try again.'
              )
            }
          } finally {
            this.isLoading = false
          }
        }
      })
    } else if (paymentType === 'promptpay') {
      let confirmPaymentResult = null
      try {
        confirmPaymentResult = await this.confirmPayment(paymentType)
        if (!confirmPaymentResult) {
          throw new Error('Payment confirmation failed. Please try again.')
        }

        const expiresAtMoment = Moment().add(PROMPTPAY_EXPIRY_MINUTES, 'minutes')
        const expiresAt = expiresAtMoment.toISOString()

        let data_req = this.dataPaymentResult()
        const res = await ApiClient.omisePayment({
          omise_token_id: null,
          omise_detail: null,
          omise_type: 'promptpay',
          booking_id: confirmPaymentResult.booking_id,
          ref_no: confirmPaymentResult.ref_no,
          total: confirmPaymentResult.total,
          payment_result: confirmPaymentResult,
          expires_at: expiresAt,
          data_req
        })

        if (res && res.data) {
          if (res.data.message === 'pending_payment' && res.data.qr) {
            this.promptpayQrUrl = res.data.qr
            this.showPromptpayQrCode = true
            this.pollTimedOut = false
            this.prepareQrFile()
            this.startPromptpayCountdown(expiresAtMoment)
            this.startPaymentPolling(confirmPaymentResult.ref_no)
          } else {
            alert(res.data.message || 'PromptPay request failed. Please try again.')
          }
        } else {
          alert('PromptPay request failed. Please try again.')
        }
      } catch (error) {
        console.error('PromptPay confirmation error:', error)
        const errorCode = error.response && error.response.data && error.response.data.error
        if (errorCode === 'existing_payment' && confirmPaymentResult) {
          this.allowLeave = true
          this.$router.push({ name: 'PaymentResult', query: { ref_no: confirmPaymentResult.ref_no, is_update_booking: this.bookingReview.isUpdateBooking || false } })
        } else {
          alert(
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : 'An error occurred during PromptPay confirmation. Please try again.'
          )
        }
      } finally {
        this.isLoading = false
      }
    } else if (paymentType.startsWith('mobile_banking_')) {
      this.$store.commit('setIsLoading', true)
      this.waitingPaymentTimeout = setTimeout(() => {
        this.waitingPaymentTimeout = null
        this.$store.commit('setIsLoading', {
          isLoading: true,
          text: this.$t('booking_review.waiting_for_payment'),
          cancel: true
        })
      }, 3000)
      let confirmPaymentResult = null
      try {
        confirmPaymentResult = await this.confirmPayment(paymentType)
        if (!confirmPaymentResult) {
          throw new Error('Payment confirmation failed. Please try again.')
        }
        let data_req = this.dataPaymentResult()
        const params = new URLSearchParams({
          ref_no: confirmPaymentResult.ref_no,
          is_update_booking: this.bookingReview.isUpdateBooking || false,
          prevRoute: this.originalPrevRoute,
          currentRoute: this.$route.fullPath || '',
        })
        const res = await ApiClient.omisePayment({
          omise_token_id: null,
          omise_detail: null,
          omise_type: paymentType,
          booking_id: confirmPaymentResult.booking_id,
          ref_no: confirmPaymentResult.ref_no,
          total: confirmPaymentResult.total,
          payment_result: confirmPaymentResult,
          return_uri: `${this.returnUrl}?${params.toString()}`,
          data_req
        })

        if (res && res.data) {
          if (res.data.message === 'pending_authorization' && res.data.authorize_uri) {
            window.location.href = res.data.authorize_uri
          } else {
            alert(res.data.message || 'Mobile banking payment request failed. Please try again.')
          }
        } else {
          alert('Mobile banking payment request failed. Please try again.')
        }
      } catch (error) {
        console.error('Mobile banking payment error:', error)
        const errorCode = error.response && error.response.data && error.response.data.error
        if (errorCode === 'existing_payment' && confirmPaymentResult) {
          this.allowLeave = true
          this.$router.push({ name: 'PaymentResult', query: { ref_no: confirmPaymentResult.ref_no, is_update_booking: this.bookingReview.isUpdateBooking || false } })
        } else {
          alert(
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : error.response && error.response.data && error.response.data.error
              ? error.response.data.error
              : 'An error occurred during mobile banking payment. Please try again.'
          )
        }
      } finally {
        this.isLoading = false
      }
    }
  }

  startPromptpayCountdown(expiresAtMoment) {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }

    const expMoment = expiresAtMoment || Moment().add(PROMPTPAY_EXPIRY_MINUTES, 'minutes')
    
    this.timeAt = expMoment
      .clone()
      .locale(this.$i18n.locale)
      .format('H:mm, ddd DD MMM YYYY')

    this.interval = setInterval(() => {
      const now = Moment()
      const remaining = expMoment.diff(now)

      if (remaining <= 0) {
        this.countDown = Moment(0)
        clearInterval(this.interval)
        this.interval = null
        this.stopPaymentPolling(true)
        return
      }

      this.countDown = Moment(remaining)
    }, 1000)
  }

  startPaymentPolling(refNo) {
    if (this.pollPaymentInterval) {
      clearInterval(this.pollPaymentInterval)
      this.pollPaymentInterval = null
    }
    this.isPollingPayment = true
    this.pollTimedOut = false

    let inflight = false

    this.pollPaymentInterval = setInterval(async () => {
      if (inflight) return
      inflight = true
      try {
        const res = await ApiClient.checkPaymentStatus(refNo)
        const data = res && res.data ? res.data : null
        if (!data) return

        if (data.success === true && data.booking_id) {
          this.stopPaymentPolling(false)
          if (this.interval) {
            clearInterval(this.interval)
            this.interval = null
          }
          this.allowLeave = true
          this.$router.push({
            name: 'PaymentResult',
            query: {
              ref_no: refNo,
              is_update_booking: this.bookingReview.isUpdateBooking || false,
            },
          })
        }
      } catch (e) {
        console.log('checkPaymentStatus pending:', e && e.response && e.response.data)
      } finally {
        inflight = false
      }
    }, PAYMENT_POLL_INTERVAL_MS)
  }

  stopPaymentPolling(timedOut = false) {
    if (this.pollPaymentInterval) {
      clearInterval(this.pollPaymentInterval)
      this.pollPaymentInterval = null
    }
    this.isPollingPayment = false
    if (timedOut) {
      this.pollTimedOut = true
    }
  }

  async refreshPromptpayQr() {
    if (!this.tempPreBooking || !this.tempPreBooking.booking_id) {
      console.error('No existing pre-booking found to refresh QR')
      alert('Cannot generate new QR. Please try again.')
      return
    }

    this.isLoading = true
    this.stopPaymentPolling(false)
    this.showPromptpayQrCode = false
    this.promptpayQrUrl = null
    this.qrFile = null
    if (this.qrPreviewUrl) {
      URL.revokeObjectURL(this.qrPreviewUrl)
      this.qrPreviewUrl = null
    }

    try {
      const refNo = this.tempPreBooking.ref_no || this.tempPreBooking.refno
      const expiresAtMoment = Moment().add(PROMPTPAY_EXPIRY_MINUTES, 'minutes')
      const expiresAt = expiresAtMoment.toISOString()

      let data_req = this.dataPaymentResult()
      const res = await ApiClient.omisePayment({
        omise_token_id: null,
        omise_detail: null,
        omise_type: 'promptpay',
        booking_id: this.tempPreBooking.booking_id,
        ref_no: refNo,
        total: this.tempPreBooking.total,
        payment_result: this.tempPreBooking,
        expires_at: expiresAt,
        data_req,
      })

      if (res && res.data && res.data.message === 'pending_payment' && res.data.qr) {
        this.promptpayQrUrl = res.data.qr
        this.showPromptpayQrCode = true
        this.pollTimedOut = false
        this.prepareQrFile()
        this.startPromptpayCountdown(expiresAtMoment)
        this.startPaymentPolling(refNo)
      } else {
        this.pollTimedOut = true
        alert((res && res.data && res.data.message) || 'Failed to generate new QR. Please try again.')
      }
    } catch (error) {
      console.error('refreshPromptpayQr error:', error)
      const errorCode = error.response && error.response.data && error.response.data.error
      if (errorCode === 'existing_payment' && this.tempPreBooking) {
        this.allowLeave = true
        this.$router.push({ name: 'PaymentResult', query: { ref_no: this.tempPreBooking.ref_no || this.tempPreBooking.refno, is_update_booking: this.bookingReview.isUpdateBooking || false } })
      } else {
        this.pollTimedOut = true
        alert(
          error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : error.response && error.response.data && error.response.data.error
            ? error.response.data.error
            : 'Failed to generate new QR. Please try again.'
        )
      }
    } finally {
      this.isLoading = false
    }
  }

  cancelPromptpay() {
    this.stopPaymentPolling(false)
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
    this.isPromptpay = false
    this.promptpayQrUrl = null
    this.qrFile = null
    if (this.qrPreviewUrl) {
      URL.revokeObjectURL(this.qrPreviewUrl)
      this.qrPreviewUrl = null
    }
    this.showPromptpayQrCode = false
    this.pollTimedOut = false
  }

  async prepareQrFile() {
    this.qrFile = null
    if (this.qrPreviewUrl) {
      URL.revokeObjectURL(this.qrPreviewUrl)
      this.qrPreviewUrl = null
    }
    const src = this.promptpayQrUrl
    if (!src || !src.startsWith('data:')) return

    try {
      let raw = await (await fetch(src)).blob()

      if (raw.type.includes('svg')) {
        let text = await raw.text()

        if (!/<svg[^>]*\swidth=/i.test(text)) {
          text = text.replace(/<svg/i, '<svg width="740" height="1050"')
        }

        if (!/xlink:href/i.test(text)) {
          text = text
            .replace(/<svg/i, '<svg xmlns:xlink="http://www.w3.org/1999/xlink"')
            .replace(/<image([^>]*?)\shref=/gi, '<image$1 xlink:href=')
        }

        const url = URL.createObjectURL(new Blob([text], { type: 'image/svg+xml' }))
        try {
          const img = new Image()
          img.src = url
          await (img.decode ? img.decode() : new Promise((ok, no) => {
            img.onload = ok
            img.onerror = no
          }))

          const scale = 2
          const canvas = document.createElement('canvas')
          canvas.width = 740 * scale
          canvas.height = 1050 * scale
          const ctx = canvas.getContext('2d')
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(0, 0, canvas.width, canvas.height)
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height)

          raw = await new Promise((ok, no) => {
            canvas.toBlob(b => (b ? ok(b) : no(new Error('toBlob failed'))), 'image/png')
          })
        } finally {
          URL.revokeObjectURL(url)
        }
      }

      this.qrFile = new File([raw], `promptpay-qr-${Date.now()}.png`, { type: raw.type })
      this.qrPreviewUrl = URL.createObjectURL(raw)
    } catch (e) {
      console.error('Prepare QR failed:', e)
    }
  }

  async savePromptpayQr() {
    const file = this.qrFile
    if (!file) return

    const isIOS = /iP(hone|ad|od)/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

    if (isIOS && navigator.canShare && navigator.canShare({ files: [file] })) {
      try {
        await navigator.share({ files: [file] })
        return
      } catch (e) {
        if (e.name === 'AbortError') return
      }
    }

    const url = URL.createObjectURL(file)
    const a = Object.assign(document.createElement('a'), { href: url, download: file.name })
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 1000)
  }

  dataPaymentResult() {
    const bookingDetailStr = window.localStorage.getItem('booking_detail')
    const paymentBodyStr = window.localStorage.getItem('payment_body')
    const bookingDetailJson = JSON.parse(bookingDetailStr)
    const paymentBodyJson = JSON.parse(paymentBodyStr)

    if (this.bookingReview.isUpdateBooking) {
      const bookingReview = bookingDetailJson
      let type;
      if (bookingReview.type === "one-time") {
        if (bookingReview.method === 0) {
          type = Constant.ONE_TIME_AUTO_SELECT;
        } else {
          type = Constant.ONE_TIME_MANUAL_SELECT;
        }
      } else {
        type = Constant.MULTI_PACKAGE;
      }

      const payload = {
        calendar: bookingReview.calendar,
        location_latitude: bookingReview.location.latitude || 0,
        location_longitude: bookingReview.location.longitude || 0,
        location_place_id: bookingReview.location.place_id || "",
        location_name: bookingReview.location.main_text || "",
        location_secondary: bookingReview.location.secondary_text || "",
        location_additional_details: bookingReview.location.additional_details || "",
        accommodation: bookingReview.accommodation.value,
        duration: bookingReview.duration.value,
        service: bookingReview.services ? bookingReview.services.value.split("_") : [],
        additional_info: [...bookingReview.additional],
        description: bookingReview.description ? bookingReview.description : "",
        maid_id: bookingReview.maid ? bookingReview.maid.id : null,
        type,
        multi_times: bookingReview.multi_times,
        website_language: window.localStorage.getItem("locale")
          ? window.localStorage.getItem("locale").toUpperCase()
          : "TH",
        total_price : parseFloat((bookingReview.total * 1.07).toFixed(2))
      };
      payload.ref_no = paymentBodyJson.refno;
      if (bookingReview.isChangeMaid) {
        payload.maid_id = type === Constant.ONE_TIME_AUTO_SELECT ? null : bookingReview.maid.id;
        payload.calendar_passed = bookingReview.calendarPassed || [];
        payload.bring_equipment = get(bookingReview, "equipment.bring_equipment", false);
        payload.total_price = bookingReview.total_price + parseFloat((bookingReview.total * 1.07).toFixed(2));
        payload.payment_status = bookingReview.payment_status;
      }
      if (
        payload.maid_id &&
        bookingReview.currentType == 'ONE_TIME_AUTO_SELECT' &&
        bookingReview.status !== 'AWAITING' &&
        bookingReview.currentMaid &&
        bookingReview.currentMaid.id == payload.maid_id
      ) {
        payload.type = Constant.ONE_TIME_AUTO_SELECT
      }
      if (bookingReview.isChangeMaid) {
        payload.calendar = payload.calendar.map((calendar) => {
          return { ...calendar, block_start: true, block_end: true };
        });
        payload.payment_status = bookingReview.payment_status
        return {
          type: 'copy_booking',
          data: payload,
          id: bookingReview.id
        }
      } else {
        return {
          type: 'update_booking',
          data: payload,
          id: bookingReview.id
        }
      }
    } else {
      return {
        type: 'new_booking',
        data: JSON.parse(localStorage.confirmPayment)
      }
    }
  }


  toPaymentResult() {
    const paymentBodyStr = window.localStorage.getItem('payment_body')
    const paymentBodyJson = JSON.parse(paymentBodyStr)
    this.$router.push({ name: 'PaymentResult', query: { ref_no: paymentBodyJson.refno, is_update_booking: this.bookingReview.isUpdateBooking || false } })
  }

  get countDownHour() {
    if (!this.countDown || typeof this.countDown.format !== 'function') {
      return this.$i18n.locale === 'en' ? '00:00 mins' : '00:00 นาที'
    }
    const display = this.countDown.format('mm:ss')
    return this.$i18n.locale === 'en' ? `${display} mins` : `${display} นาที`
  }


  get cannotSubmit() {
    if (!this.countDown || typeof this.countDown.format !== 'function') {
      return true
    }
    let cannotSubmit = false
    if (this.countDown.format('mm:ss') == '00:00') {
      cannotSubmit = true
    }
    return cannotSubmit
    // let time = null;
    // if (this.isBank) {
    //   time = Moment(60 * 60 * 1000);
    // } else {
    //   time = null;
    // }
    // console.log("countDownHour");
    // if (this.$i18n.locale === "en") {
    //   return `${this.countDown.format("mm")} mins`;
    // } else return `${this.countDown.format("mm")} นาที`;
  }

  get creditCardFormValid() {
    return (
      this.cardName.trim() !== '' &&
      this.cardNumber.replace(/\s/g, '').length === 16 &&
      /^\d{2}\/\d{2}$/.test(this.cardExpiry) &&
      this.cardCvv.length === 3
    )
  }

  @Watch('isLoggedIn')
  async onIsLoggedInChanged(newval) {
    if (newval && this.isClickConfirmBooking) {
      this.isLoading = true
      if (!this.bookingReview.coupon_body) {
        await this.doBooking()
      }
    }
  }

  @Watch('email')
  async onIsEmailChanged(newval) {
    if (this.isLoggedIn && this.bookingReview.coupon_body) {
      this.isLoading = true
      let booking_detail_local = JSON.parse(localStorage.booking_detail)
      this.coupon = booking_detail_local.coupon_body.code
      await this.applyCoupon()
      this.isLoading = false
      if (
        typeof this.bookingReview.coupon_body &&
        this.bookingReview.coupon_body &&
        this.isClickConfirmBooking
      ) {
        await this.doBooking()
      }
    }
  }

  @Watch('showBookingReview')
  async onShowBookingReviewChanged(newval) {
    this.$store.commit('setIsLoading', !newval)
  }

  savePaymentBodyToLocalStorage(paymentBody) {
    window.localStorage.setItem('payment_body', JSON.stringify(paymentBody))
  }

  saveBookingDetailToLocalStorage() {
    if (
      !this.bookingReview.isUpdateBooking ||
      (this.bookingReview.isUpdateBooking && parseInt(this.amount) > 0)
    ) {
      this.paymentType === 'card' || this.paymentType === 'promptpay' || this.paymentType === 'mobile_banking'
        ? (this.bookingReview.payment_status = 'ONLINE_BANKING_WAITING')
        : (this.bookingReview.payment_status = 'BANK_TRANSFER_WAITING')
    }
    // console.log("this.bookingReview", this.bookingReview);

    window.localStorage.setItem('booking_detail', JSON.stringify(this.bookingReview))
  }

  get headerText() {
    return this.$t('booking_review.heading')
  }

  get confirmButtonText() {
    return this.bookingReview.isUpdateBooking
      ? this.$t('button.confirm_update')
      : this.$t('button.confirm_booking')
  }

  get isBookingOneTime() {
    return this.bookingReview.type === 'one-time'
  }

  get paymentBody() {
    const refno = Moment().format('X')
    const total =  this.totalString
    // const total = isProduction() ? this.totalString : '1'
    const { merchantid, customeremail, productdetail } = this.paymentValue
    const postbackParams = `?merchantid=${merchantid}&status=completed&refno=${refno}&customeremail=${encodeURIComponent(customeremail)}&productdetail=${productdetail}&total=${total}`

    // return { ...this.paymentValue, refno: Moment().format('X'), total: this.totalString }
    // const total = '1'
    if (this.bookingReview.isUpdateBooking) {
      return {
        ...this.paymentValue,
        refno: this.bookingReview.total > 0 ? refno : null,
        total,
        coupon: this.coupon,
        postbackurl: postbackurl + postbackParams,
        returnurl: this.returnUrl,
      }
    }
    return {
      ...this.paymentValue,
      refno,
      total,
      coupon: this.coupon,
      postbackurl: postbackurl + postbackParams,
      returnurl: this.returnUrl,
    }
  }

  get bookingType() {
    if (!this.bookingReview.type) return ''
    return this.bookingReview.type === 'one-time'
      ? this.$t('commons.book_one_time')
      : this.$t('commons.book_multi_package')
  }

  get additional() {
    const additionals = this.bookingReview.additional.map((val) => {
      return Constant.ADDITIONAL_INFO.find((option) => option.value === val).text
    })
    return additionals.map((text) => this.$t(`check_box.${text}`))
  }

  get amount() {
    return parseFloat(this.bookingReview.amount).toFixed(2)
  }

  get vat() {
    return (parseFloat(this.bookingReview.total) * 0.07).toFixed(2)
    //return parseFloat(0).toFixed(2) // fix me (use above value when we calculate total including vat)
  }

  get totalExcludeVat() {
    return (parseFloat(this.totalString) * 0.93).toFixed(2)
  }

  get totalDiscount() {
    return parseFloat(this.discount).toFixed(2)
  }

  get totalString() {
    const total = parseFloat(this.bookingReview.total * 1.07).toFixed(2)
    // dataLayer.push({'event':'order_confirm','order_value':total});
    return total
    //return parseFloat(this.bookingReview.total).toFixed(2) // fix me (Use above value)
  }

  get fullName() {
    const maid = this.bookingReview.maid
    if (maid) {
      return maid.user.first_name + ' ' + maid.user.last_name
    }
    return ''
  }

  get service() {
    const serviceText = this.bookingReview.services ? this.bookingReview.services.text : ''
    if (this.bookingReview.calendar.length === 0) return serviceText
    const startDate = this.$momentTZ(this.bookingReview.calendar[0].start_datetime)
    const endDate = this.$momentTZ(this.bookingReview.calendar[0].end_datetime)

    // Fix me (services)  ${startDate.format('H:mm')} - ${endDate.format('H:mm')}
    return `${serviceText} `
  }

  get serviceTime() {
    if (this.bookingReview.calendar.length === 0) return serviceText
    const startDate = this.$momentTZ(this.bookingReview.calendar[0].start_datetime)
    const endDate = this.$momentTZ(this.bookingReview.calendar[0].end_datetime)

    return `${startDate.format('H:mm')} - ${endDate.format('H:mm')}`
  }

  get location() {
    const locationPin = this.bookingReview.location.main_text
    return `${locationPin} `
  }

  get place() {
    const secondPin = this.bookingReview.location.secondary_text
    return `${secondPin} `
  }

  get additional_details() {
    const additionalDetails = this.bookingReview.location.additional_details
    console.log('addigtoinal adial', additionalDetails)
    if (additionalDetails) {
      return `${additionalDetails}`
    }
    return null
  }

  get booking_type() {
    let isOTA = this.bookingReview.type === 'one-time' && this.bookingReview.method === 0
    let isOTM = this.bookingReview.type === 'one-time' && this.bookingReview.method === 1
    if (isOTA) {
      return Constant.ONE_TIME_AUTO_SELECT
    }
    if (isOTM) {
      return Constant.ONE_TIME_MANUAL_SELECT
    }

    return Constant.MULTI_PACKAGE
  }

  get startDateLabel() {
    if (this.bookingReview.calendar.length === 0) return date.format(template)
    const date = Moment(this.bookingReview.calendar[0].start_datetime)
    const template = this.$i18n.locale === 'th' ? 'ddd DD MMM YYYY' : 'ddd MMM DD, YYYY'
    return date.format(template)
  }
  // discount for front only (ex Jan 31 2021)
  async applyCoupon() {
    let canUse =
      this.coupon.toUpperCase() === 'WELCOME10' || this.coupon.toLowerCase() === 'welcome10'
    let body = {
      code: this.coupon.toUpperCase(),
      price: this.bookingReview.amount,
      used: false,
      booking_type: this.booking_type,
    }
    // console.log('booking_type', this.booking_type)

    let date = new Date()
    let timestamp_now = date.getTime()

    let timestamp_end = 1655312400000

    if (canUse && this.booking_type !== 'MULTI_PACKAGE') {
      if (!this.isLoggedIn) {
        this.discount = this.bookingReview.amount * 0.1
        this.bookingReview.total = this.bookingReview.amount - this.discount
        this.bookingReview.coupon_body = body
        this.saveBookingDetailToLocalStorage()
        this.couponStatusLabel = this.$t('booking_review.coupon_applied')

        return
      }
      let re = null

      try {
        re = await ApiClient.applyCoupon(body)
        let { discount_price } = re.data
        if (discount_price) {
          this.discount = discount_price
          this.bookingReview.total = this.bookingReview.amount - this.discount
          this.bookingReview.coupon_body = body
          this.setDiscountPrice(this.discount)
          this.couponStatusLabel = this.$t('booking_review.coupon_applied')
          this.saveBookingDetailToLocalStorage()
        }
      } catch (e) {
        this.clearPromotion()
        if (e.response.data.error === 'first_time_booking_only') {
          this.couponStatusLabel = this.$t('error.coupon.first_time_booking_only')
        } else if (e.response.data.error === 'expired_code') {
          this.couponStatusLabel = this.$t('error.coupon.expired_code')
        } else {
          this.couponStatusLabel = this.$t('error.coupon.invalid_code')
        }
      }
    } else if (this.coupon.toUpperCase() === 'THAIWIN7') {
      this.bookingReview.coupon_body = true
      // let timestamp_end = 1640995199000
      if (timestamp_now < timestamp_end && this.coupon.toUpperCase() === 'THAIWIN7') {
        this.discount = (this.bookingReview.amount * 7) / 100
        this.setDiscountPrice(this.discount)
        this.bookingReview.total = this.bookingReview.amount - this.discount
        this.couponStatusLabel = this.$t('booking_review.coupon_applied')
        this.saveBookingDetailToLocalStorage()
      } else {
        this.couponStatusLabel = this.$t('booking_review.coupon_invalid')
        this.clearPromotion()
      }
    }
    ///THAIWIN7 PROMOTION
    // else if (this.coupon) {
    //   let date = new Date()
    //   let timestamp_now = date.getTime()

    //   let timestamp_end = 1651363200000 //1 May 2022

    //   // let timestamp_end = 1640995199000
    //   if (timestamp_now < timestamp_end && this.coupon.toUpperCase() === 'THAIWIN7') {
    //     this.discount = (this.bookingReview.amount * 7) / 100
    //     this.setDiscountPrice(this.discount)
    //     this.bookingReview.total = this.bookingReview.amount - this.discount
    //     this.bookingReview.is_used_promotion = false
    //     this.is_used_promotion = false

    //     this.couponStatusLabel = this.$t('booking_review.coupon_applied')
    //     this.saveBookingDetailToLocalStorage()
    //
    //   } else {
    //     this.clearPromotion()
    //   }
    // }
    else {
      if (this.booking_type == 'MULTI_PACKAGE') {
        this.couponStatusLabel = this.$t('error.coupon.first_time_booking_only')
        this.clearPromotion()
        return
      } else {
        this.couponStatusLabel = this.$t('error.coupon.invalid_code')
        this.clearPromotion()
      }
    }
  }

  get isApplySuccess() {
    return this.couponStatusLabel === this.$t('booking_review.coupon_applied')
  }
  clearPromotion() {
    this.discount = 0
    this.bookingReview.is_used_promotion = false
    this.is_used_promotion = false
    this.bookingReview.total = this.bookingReview.amount
    this.bookingReview.coupon_body = null
    this.saveBookingDetailToLocalStorage()
  }

  get equipment() {
    const equipmentOption = this.getDefaultEquipmentOption({
      bring_equipment: get(this.bookingReview, 'equipment.bring_equipment', false),
    })

    const text = equipmentOption.text.split(') ')[1] // remove price (+xx THB)

    return { ...equipmentOption, text }
  }

  dateTimeTimezone = ''
  getDateTimeTimezone() {
    const d = new Date()

    // Get date components
    const day = d.getDate()
    const month = d.getMonth() + 1 // Month is zero-based, so add 1
    const year = d.getFullYear()

    // Get time components
    const hours = d.getHours()
    const minutes = d.getMinutes()

    // Get timezone offset in minutes
    const timezoneOffset = d.getTimezoneOffset()

    // Convert timezone offset to hours and minutes
    const absTimezoneOffsetHours = Math.abs(timezoneOffset / 60)
    const timezoneOffsetHours = Math.floor(absTimezoneOffsetHours)
    const timezoneOffsetMinutes = Math.abs(timezoneOffset % 60)

    // Determine the sign of the timezone offset
    const timezoneSign = timezoneOffset >= 0 ? '-' : '+'

    // Format the date/time and timezone
    const formattedDateTime = `${day}/${month}/${year} ${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}`
    const formattedTimezone = `(GMT${timezoneSign}${
      timezoneOffsetHours < 10 ? '0' : ''
    }${timezoneOffsetHours}:${timezoneOffsetMinutes < 10 ? '0' : ''}${timezoneOffsetMinutes})`

    return `${formattedDateTime} ${formattedTimezone}`
  }
}
</script>

<style scoped lang="scss">
#payment_method {
  width: 16px;
  height: 16px;
  display: inline-block;
  vertical-align: middle;
  padding: 0;
}

@media (max-width: 767.98px) {
  .mb-mobile-150 {
    margin-bottom: 150px !important;
  }
}

.w-promptpay{
  width: 80px !important;
  height: auto;
}

.w-credit{
  width: 100px !important;
  height: auto;
}

.flex-col
{
  display: flex;
  flex-direction: column;
}

.ml-gap-bank {
  margin-left: 25px;
  width: 160px;
}

.ml-gap-credit {
  margin-left: 25px;
  width: 160px;
}

.text-timestamp {
  font-size: 12px;
  margin-top: 10px;
  opacity: 0.7;
}

.width-image-modal {
  width: -webkit-fill-available;
  height: inherit;
}
.fullname {
  margin-top: 20px;
}

.date,
.cleaning-type {
  margin: 0;
}
.translateYg {
  transform: translateeY(100px) !important;
}
.warning-confirm {
  text-align: right;
}
.description {
  word-wrap: break-word;
}

.text-grey {
  color: #757575;
}

.warning-maid {
  font-size: 0.8rem;
}

.avatar {
  width: 70px;
  height: 70px;
  border-radius: 64px;
}
.cc-number {
  height: 24px;
  display: flex;
  align-items: center;
}
.width_180 {
  width: 180px !important;
}

.payment-detail {
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  margin: 1em 0;
  font-size: 16px;
  color: #333333;
}
#map {
  height: 350px;
  // background: red;
}
@media screen and (max-width: 1199px) {
  .input-text-area {
    &-1 {
      display: none;
    }
  }
}
@media screen and (min-width: 1200px) {
  .input-text-area {
    &-2 {
      display: none;
    }
  }
}

@media screen and (min-width: 426px) {
  .input-text-area {
    &-2 {
      display: none;
    }
  }

  .img_rigth {
    position: relative;
    right: -50%;
  }
}

.map-container {
  width: 100%;
  display: flex;
}

.map-iframe {
  width: 79%;
  height: 350px;
  margin-left: 24px;
}

@media screen and (max-width: 1200px) {
  .map-iframe {
    width: 100%;
    margin-left: 0;
  }
}

.contents-center {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.border-payment{
  border: 1px solid #005eff3f;
  border-radius: 5px;
  padding: 10px;
  padding-left: 20px;
}

.bank-grid {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.bank-box {
  width: 100%;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  opacity: 1;
  transform: rotate(0deg);
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.bank-box--selected {
  border-color: #2b7cff;
  background: #E3EEFF;
  box-shadow: 0 3px 12px rgba(43,124,255,0.15);
}

.bank-icon {
  width: 40px;
  height: auto;
  margin-right: 20px;
  flex-shrink: 0;
}

.bank-name {
  font-weight: 400;
  color: #333;
}

.button-cancel{
  width: 100%;
  border: 2px solid #005DFF;
  border-radius: 6px;
}

.button-cancel-disabled{
  width: 100%;
  border: 2px solid gray;
  border-radius: 6px;
  opacity: 0.5;
  cursor: not-allowed;
}

.max-500px{
  max-width: 500px;
  margin: 0 auto;
}

.text-start{
  text-align: left;
}

.gap-4{
  gap: 12px;
}

.button-cancel:hover{
  text-decoration: none;
}

.button-confirm{
  width: 100%;
  background-color: #005DFF;
  border: none;
  border-radius: 6px;
  color: white;
}

.text-nowarp{
  white-space: nowrap;
}

.credit-type-img {
  object-fit: contain;
  width: 60px;
  height: auto;
  margin-left: 8px;
  display: inline-block;
}

.cc-input-group {
  position: relative;
}

.cc-input-group .credit-type-img {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  width: 60px;
  height: auto;
  object-fit: contain;
}

.cc-input-group .form-control {
  border-top-right-radius: 0.25rem !important;
  border-bottom-right-radius: 0.25rem !important;
}

.cc-input-group .form-control {
  padding-right: 84px; 
}


.cvv-input-group {
  position: relative;
}
.cvv-input-group .form-control {
  padding-right: 40px; 
}
.cvv-info-img {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 14px;
  height: 14px;
  cursor: pointer;
  pointer-events: auto;
}
</style>